<div class="modal-content">
  <div class="modal-header">
    Download The User Guide
    <i class="material-icons" data-bs-dismiss="modal" (click)="closeModal()">close</i>
  </div>
  <div class="fix-height-modal">
    <div class="modal-body">
      <div class="form-group clearfix">
        <div class="col-sm-6 col-xs-12" style="display: inline-block;">
          <div class="user-guide-img-new">
            <img id="previewImage" class="img-responsive" src="../../../../assets/img/user-guide_character.png" alt="">
          </div>
        </div>
        <div class="col-sm-6 col-xs-12" id="user-guide-msg" style="display: inline-block;">
          <div>{{isAdmin ? adminText : nonAdminText}}</div>
          @if (isAdmin) {
            <select class="form-control" style="margin-top: 15px;"
              [(ngModel)]="selectedUserGuide">
              @for (guide of userGuideTypes; track guide) {
                <option [ngValue]="guide">{{guide}}</option>
              }
            </select>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" (click)='closeModal()'>Cancel</button>
    <button type="button" class="btn btn__btn-default btn__orange" (click)="downloadUserGuide()">Download</button>
  </div>
</div>
